var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
export var GRID_UNIT = 4;
export var APP_FONT_FAMILY = "'Poppins', 'IBM Plex Sans', sans-serif";
export var SERIF_FONT_FAMILY = "'IBM Plex Serif', freight-text-pro, 'Georgia', 'Times New Roman', serif";
export var SANS_FONT_FAMILY = "'IBM Plex Sans', 'Helvetica Neue', 'Open Sans', sans-serif";
export var MONO_FONT_FAMILY = "'IBM Plex Mono', 'consolas', 'monospace'";
export var CONDENSED_FONT_FAMILY = "'IBM Plex Sans Condensed', 'Arial Narrow', 'sans-serif'";
export var SDG_COLORS = {
  affordableCleanEnergy: '#FBC410',
  cleanerWaterSanitation: '#29BFE6',
  climateAction: '#417F46',
  decentWorkAndEconomicGrowth: '#A31D44',
  genderEquality: '#EE402D',
  goodHealthAndWellbeing: '#4CA146',
  industryInnovationAndInfrastructure: '#F16A2F',
  lifeBelowWater: '#1E97D4',
  lifeOnLand: '#58BA47',
  noPoverty: '#E5233D',
  partnerships: '#15496B',
  peaceJusticeAndStrongInstitutions: '#15699F',
  qualityEducation: '#C7212F',
  reducedInequalities: '#E11484',
  responsibleConsumptionAndProduction: '#BF8D2C',
  sustainableCitiesAndCommunities: '#F89D2A',
  zeroHunger: '#DDA739'
};
// ------------------------------ LIGHT (DEFAULT) COLOR SET ------------------------------>
/*

  QUESTIONS:
  - Do we even provide defaults for components? The defaults feel like they should always be the fallbacks
  - If we provide defaults it means that both light and dark would need to be defined, or the extension of
  - light colors would need to be "dark-aware"
  
*/
export var DEFAULT_LIGHT_COLORS = {
  // allow light and dark colors which should be the same if it'slight or dark mode. Sometimes you just need "white" or "black" regardless of mode
  dark: '#000000',
  light: '#FFFFFF',
  // mode-sensitive colors
  canvas: '#FFFFFF',
  appChrome: '#EBEBEB',
  strongChrome: '#333333',
  textChrome: '#222222',
  subtleChrome: '#F3F3F3',
  verySubtleChrome: '#F9F9F9',
  // DEPRECATED - THESE SHOULD BE MIGRATED TO canvas and appChrome
  bright: '#FFFFFF',
  brightWarm: '#EBEBEB',
  strong: '#000000',
  sub: '#00000099',
  text: '#000000AA',
  mid: '#00000088',
  subtle: '#00000055',
  verySubtle: '#00000022',
  justVisible: '#00000011',
  primary: '#FCB017',
  primaryDarker: '#F7941C',
  primaryLight: '#FEE7B9',
  primaryLighter: '#FFCB03',
  primaryBright: '#FCB017',
  primaryVeryLight: '#FFF1BD',
  secondary: '#333333',
  submit: 'yellowgreen',
  error: '#FF0000',
  accentLight: '#FEE7B9',
  accentDark: '#F7941C',
  highlight: '#FFFBF2',
  textTag: '#777777',
  textFade: '#8E8E8E',
  textMid: '#969696',
  textSidebar: '#8B8B8B',
  textSubtle: '#ABABAB',
  textVerySubtle: '#BFC0BF',
  textInverted: '#FFF',
  textInvertedSubtle: '#AAA',
  textDisabled: '#DDD',
  textTitle: '#0D0D0D',
  h1: '#000000',
  h2: '#000000',
  h3: '#000000',
  h4: '#000000',
  h5: '#000000',
  h6: '#000000',
  bullet: '#000000',
  bold: '#0D0D0D',
  line: '#00000066',
  lineSubtle: '#00000022',
  lineMid: '#00000044',
  lineFilter: '#00000022',
  lineDark: '#00000066',
  lineSidebar: '#00000017',
  lineSidebarSubtle: '#00000019',
  lineSemiSubtle: '#00000025',
  lineVerySubtle: '#00000011',
  link: '#205AA0',
  linkHover: '#E1A449',
  linkActive: '#E1A449',
  textHighlight: '#56C02B',
  navigationActive: '#FCB017',
  textBubble: '#969696',
  formHeader: '#F5F5F5',
  tableHeader: '#F5F5F5',
  tableLightHeader: '#FCFCFC',
  formPanel: '#FCFCFC',
  dialogBody: '#FFFBF3',
  footer: '#333333',
  sdg: SDG_COLORS,
  subtleShadow: '#00000022',
  subtleMidGrey: '#EBEBEB',
  // these are "suggested" colors for various real world colors, but not sure how useful this is so they may be removed
  blue: '#205AA0',
  grey: '#A1A1A1',
  orange: '#F05A29',
  yellow: '#FFCA04',
  yellowOrange: '#FFA000',
  green: '#009900',
  lime: '#79AF02',
  button: '#000000',
  buttonHover: '#333333'
};
// NB: Dark colors use LIGHT colors as a base and extends them
// ------------------------------ DARK COLOR SET ------------------------------>
export var DEFAULT_DARK_COLORS = __assign(__assign({}, DEFAULT_LIGHT_COLORS), {
  dark: '#000000',
  light: '#FFFFFF',
  canvas: '#1E1E1E',
  textChrome: '#999999',
  appChrome: '#333333',
  subtleChrome: '#222222',
  verySubtleChrome: '#111111',
  strongChrome: '#CCCCCC',
  strong: '#FFFFFF',
  sub: '#FFFFFFCC',
  mid: '#FFFFFF88',
  text: '#FFFFFFDD',
  subtle: '#FFFFFF55',
  verySubtle: '#FFFFFF2C',
  justVisible: '#FFFFFF1C',
  // DEPRECATED - THESE SHOULD BE MIGRATED TO canvas and appChrome
  bright: '#1E1E1E',
  brightWarm: '#333333',
  h1: '#FFFFFF',
  h2: '#FFFFFF',
  h3: '#FFFFFF',
  h4: '#FFFFFF',
  h5: '#FFFFFF',
  h6: '#FFFFFF',
  highlight: '#333333',
  textHighlight: '#56C02B',
  bullet: '#FFFFFF',
  subtleShadow: '#FFFFFF22',
  line: '#FFFFFF66',
  lineSubtle: '#FFFFFF44',
  lineMid: '#FFFFFF44',
  lineFilter: '#FFFFFF22',
  lineDark: '#FFFFFF66',
  lineSidebar: '#FFFFFF1E',
  lineSidebarSubtle: '#FFFFFF19',
  lineSemiSubtle: '#FFFFFF33',
  lineVerySubtle: '#FFFFFF11',
  link: '#FFFFFF',
  linkHover: '#FFFFFF',
  linkActive: '#FFFFFF',
  button: '#FFFFFF',
  buttonHover: '#FFFFFF'
});
export var DEFAULT_THEME = {
  duration: 0.3,
  activeMode: 'light',
  light: {
    color: DEFAULT_LIGHT_COLORS,
    opacity: {
      strong: 1,
      sub: 0.6,
      mid: 0.4,
      subtle: 0.3
    }
  },
  dark: {
    color: DEFAULT_DARK_COLORS,
    opacity: {
      strong: 1,
      sub: 0.8,
      mid: 0.5,
      subtle: 0.4
    }
  },
  grid: {
    unit: GRID_UNIT,
    /* bracket sizes in multiples of grid unit */
    bracket: {
      normal: {
        base: 4,
        landscape: 4,
        tablet: 10,
        desktop: 16,
        desktopLarge: 20
      }
    },
    icon: {
      normal: {
        base: 8,
        landscape: 8,
        tablet: 10,
        desktop: 16,
        desktopLarge: 20
      }
    }
  },
  lineHeight: {
    copy: 1.6,
    heading: 1.1,
    copyTight: 1.45,
    sans: 1.35,
    serif: 1.35
  },
  font: {
    size: {
      base: 16,
      tiny: {
        base: 12,
        landscape: 12,
        tablet: 13,
        desktop: 14,
        desktopLarge: 14
      },
      verySmall: {
        base: 12,
        landscape: 13,
        tablet: 14,
        desktop: 15,
        desktopLarge: 15
      },
      small: {
        base: 14,
        landscape: 14,
        tablet: 15,
        desktop: 16,
        desktopLarge: 16
      },
      slight: {
        base: 15,
        landscape: 15,
        tablet: 16,
        desktop: 18,
        desktopLarge: 20
      },
      normal: {
        base: 16,
        landscape: 16,
        tablet: 18,
        desktop: 21,
        desktopLarge: 21
      },
      medium: {
        base: 18,
        landscape: 22,
        tablet: 24,
        desktop: 26,
        desktopLarge: 28
      },
      title: {
        base: 18,
        landscape: 22,
        tablet: 24,
        desktop: 28,
        desktopLarge: 28
      },
      large: {
        base: 22,
        landscape: 24,
        tablet: 36,
        desktop: 42,
        desktopLarge: 42
      },
      huge: {
        base: 36,
        landscape: 36,
        tablet: 64,
        desktop: 84,
        desktopLarge: 96
      }
    },
    family: {
      app: APP_FONT_FAMILY,
      serif: SERIF_FONT_FAMILY,
      sans: SANS_FONT_FAMILY,
      mono: MONO_FONT_FAMILY,
      heading: SANS_FONT_FAMILY,
      copy: SANS_FONT_FAMILY,
      condensed: CONDENSED_FONT_FAMILY
    }
  }
};
export default DEFAULT_THEME;